<template>
  <f7-page
    no-toolbar
    no-navbar
    no-swipeback
    @page:reinit="loadPersons"
  >
    <div
      v-if="userMenu"
      class="fixed right-0 mt-20 mr-5 bg-white p-6 shadow-xl rounded-lg z-50"
    >
      <a
        class="flex items-center"
        @click="askForLogout"
      >
        <eva-icon
          name="power-outline"
          fill="#FF7570"
          width="32"
          height="32"
        />
        <span class="ml-2">Cerrar sesión</span>
      </a>
    </div>
    <div v-if="loadedPersons && Object.keys(persons).length !== 0">
      <button
        v-if="!(showQRCode || alreadyReportedToday[selectedPersonID])"
        class="fixed z-40 right-0 bottom-0 mr-5 disabled:opacity-50 disabled:pointer-events-none block w-40 h-12 leading-12 bg-purple-500 text-white text-center text-xl rounded-md"
        :disabled="!canSubmit"
        @click.prevent="submitAnswers"
      >
        Confirmar
      </button>
      <div class="mx-10 mb-32 select-none">
        <a
          v-if="account.accessPoint && !isAdmin"
          class="absolute left-0 top-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-purple-500"
          href="/access-point/"
        >
          <eva-icon
            name="video-outline"
            fill="#FFFFFF"
            width="32"
            height="32"
          />
        </a>
        <a
          v-if="!isAdmin"
          class="fixed right-0 top-0 m-5 rounded-full shadow-lg p-2 leading-3 z-50"
          @click="userMenu = !userMenu"
        >
          <eva-icon
            :name="!userMenu? 'menu-outline' : 'close-outline'"
            fill="#6C63FF"
            width="32"
            height="32"
          />
        </a>
        <div>
          <div class="flex flex-col-reverse mt-4 mb-2 max-w-lg mx-auto">
            <div
              class="relative flex flex-wrap mx-auto justify-between w-10/12"
            >
              <div class="absolute w-full border-b-2 border-dashed border-gray-300 h-6 z-0" />
              <div
                v-for="(person, personID) of persons"
                :key="personID"
                :class="`z-50 w-12 h-12 rounded-full shadow-lg p-2 pb-2 text-base text-center border border-gray-300 cursor-pointer ${getSelectionClass(personID)}`"
                @click="handleSelect(personID)"
              >
                <eva-icon
                  v-if="alreadyReportedToday[personID]"
                  name="checkmark-outline"
                  fill="#FFFFFF"
                  width="24"
                  height="24"
                  class="align-text-bottom"
                />
                <div
                  v-else
                  class="text-center text-white leading-5 font-bold"
                >
                  -
                </div>
              </div>
              <div
                v-if="Object.keys(alreadyReportedToday).length === Object.keys(persons).length"
                :class="`z-50 w-8 h-8 rounded-full shadow p-2 pb-2 text-base text-center border-gray-500 cursor-pointer ${getSelectionClass('qrCode')}`"
                @click="handleSelect()"
              >
                <img
                  :class="!showQRCode ? 'opacity-50' : ''"
                  :style="showQRCode ? 'filter: invert(100%)' : ''"
                  src="@/assets/qr-code.png"
                  alt="qr-code"
                >
              </div>
            </div>
            <img
              v-if="!!selectedPersonID"
              class="w-20 mb-4"
              :src="instance.logoUrl"
              alt="logo"
            >
          </div>
          <div
            v-if="!!selectedPersonID"
          >
            <transition
              name="slide-fade"
              mode="out-in"
            >
              <div
                :key="selectedPersonID"
                ref="personLabelName"
                class="text-xl text-purple-500 font-bold text-center max-w-lg mx-auto rounded-sm p-2 break-all sticky top-0 bg-white z-30"
              >
                {{ persons[selectedPersonID].name }}
              </div>
            </transition>
            <div
              v-if="!alreadyReportedToday[selectedPersonID]"
              class="max-w-lg mx-auto"
            >
              <div
                v-if="askForVaccinationStatus && shouldAskVaccination"
                class="p-3 shadow-md rounded-sm text-md mb-5 text-center relative z-10 bg-white"
              >
                <span class="absolute flex h-3 w-3 top-0 left-0 ml-1 mt-1 overflow-visible">
                  <span class="absolute animate-ping rounded-full h-3 w-3 bg-red-400 opacity-75 overflow-visible" />
                  <span class="rounded-full h-3 w-3 bg-red-500" />
                </span>
                <div class="text-lg font-bold">
                  ¿Ya estás vacunado para COVID-19?
                </div>
                <div class="mb-4 underline">
                  (Si no tienes el esquema completo, responde NO)
                </div>
                <div
                  class="p-2 bg-white text-purple-500 cursor-pointer mb-3 w-1/2 text-center rounded-sm mx-auto border border-purple-500"
                  @click="reportVaccination('wontGetVaccinated')"
                >
                  No me voy a vacunar
                </div>
                <div class="flex justify-center w-1/2 mx-auto space-x-2">
                  <div
                    class="p-2 text-white bg-purple-500 cursor-pointer w-1/2 text-center rounded-sm"
                    @click="reportVaccination('unvaccinated')"
                  >
                    No
                  </div>
                  <div
                    class="p-2 text-white bg-green-500 cursor-pointer w-1/2 text-center rounded-sm"
                    @click="reportVaccination('vaccinated')"
                  >
                    Si
                  </div>
                </div>
              </div>
              <!-- askForVaccinationDates && shouldAskVaccination -->
              <transition
                name="slide-fade"
                mode="out-in"
              >
                <div
                  v-if="doses[currentDoseIndex] && shouldAskVaccinationDoses && !hideVaccinationQuestionary"
                  class="p-3 shadow-md rounded-sm text-md mb-5 text-center relative bg-white z-50"
                  @click="showCalendar ? showCalendar = false : ''"
                >
                  <span class="absolute flex h-3 w-3 top-0 left-0 ml-1 mt-1 overflow-visible">
                    <span class="absolute animate-ping rounded-full h-3 w-3 bg-red-400 opacity-75 overflow-visible" />
                    <span class="rounded-full h-3 w-3 bg-red-500" />
                  </span>
                  <div
                    class="text-xl font-bold text-center w-full mb-2"
                  >
                    Vacunación
                  </div>
                  <div class="text-xl font-bold mb-5">
                    ¿Ya te aplicaste <span class="text-purple-500 text-2xl">{{ doses[currentDoseIndex] }}</span>?
                  </div>
                  <div
                    class="absolute shadow-lg z-50"
                    @click.stop=""
                  >
                    <vc-date-picker
                      v-if="showCalendar"
                      v-model="selectedDate"
                      :value="null"
                      color="purple"
                      :attributes="attributes"
                      :max-date="new Date()"
                    />
                  </div>
                  <div>
                    <div
                      v-if="!isJanssen || currentDoseIndex !== 1"
                      class="my-2 text-left font-bold text-lg"
                    >
                      <input
                        id="vaccinated"
                        v-model="currentVaccinationAnswer"
                        type="radio"
                        name="reason"
                        value="vaccinated"
                        checked
                      >
                      <label
                        class="ml-2"
                        for="vaccinated"
                      >Sí</label>
                    </div>
                    <div v-if="!isJanssen || currentDoseIndex !== 1">
                      <div class="my-2 text-left font-bold text-lg">
                        <select
                          v-model="currentVaccine"
                          class="bg-purple-500 text-white font-bold rounded p-1"
                        >
                          <option value="moderna">
                            Moderna
                          </option>
                          <option value="pfizer">
                            Pfizer
                          </option>
                          <option value="sinovac">
                            Sinovac
                          </option>
                          <option value="astrazeneca">
                            AstraZeneca
                          </option>
                          <option
                            v-if="isJanssen || currentDoseIndex !== 1"
                            value="janssen"
                          >
                            Janssen
                          </option>
                        </select>
                      </div>
                    </div>
                    <div
                      v-if="!isJanssen || currentDoseIndex !== 1"
                      class="flex p-2 justify-between items-center text-white bg-purple-500 rounded-md cursor-pointer w-48"
                      @click.stop="showCalendar = !showCalendar; currentVaccinationAnswer = 'vaccinated'"
                    >
                      <div
                        class="font-bold"
                      >
                        {{ selectedDate ? formatDate(selectedDate) : 'Selecciona la fecha' }}
                      </div>
                      <eva-icon
                        class=""
                        :name="showCalendar ? 'arrow-ios-downward-outline' : 'arrow-ios-forward-outline'"
                        fill="#FFFFFF"
                      />
                    </div>
                    <div class="text-left font-bold text-lg mt-10">
                      <div
                        v-if="currentDoseIndex === 1 && isJanssen"
                        class="my-2"
                      >
                        <input
                          id="unique"
                          v-model="currentVaccinationAnswer"
                          type="radio"
                          name="reason"
                          value="unique"
                        >
                        <label
                          class="ml-2"
                          for="unique"
                        >Mi vacuna es de dosis única</label>
                      </div>
                      <div
                        v-if="!isJanssen || currentDoseIndex !== 1"
                        class="my-2"
                      >
                        <input
                          id="own"
                          v-model="currentVaccinationAnswer"
                          type="radio"
                          name="reason"
                          value="own"
                        >
                        <label
                          class="ml-2"
                          for="own"
                        >No, por <span class="text-purple-500">decisión propia</span></label>
                      </div>
                      <div
                        v-if="!isJanssen || currentDoseIndex !== 1"
                        class="my-2"
                      >
                        <input
                          id="medical"
                          v-model="currentVaccinationAnswer"
                          type="radio"
                          name="reason"
                          value="medical"
                        >
                        <label
                          class="ml-2"
                          for="medical"
                        >No, por <span class="text-purple-500">recomendación médica</span></label>
                      </div>
                      <div
                        v-if="!isJanssen || currentDoseIndex !== 1"
                        class="my-2"
                      >
                        <input
                          id="time"
                          v-model="currentVaccinationAnswer"
                          type="radio"
                          name="reason"
                          value="time"
                        >
                        <label
                          class="ml-2"
                          for="time"
                        >Aún no me la debo aplicar</label>
                      </div>
                    </div>
                    <div class="w-full flex justify-between">
                      <button
                        v-show="currentDoseIndex"
                        class="block w-40 h-12 leading-12 bg-purple-500 text-white text-center text-xl rounded-md disabled:opacity-50 disabled:pointer-events-none"
                        @click="addToVaccinationIndex(-1)"
                      >
                        Anterior
                      </button>
                      <button
                        class="ml-auto mr-0 block w-40 h-12 leading-12 bg-purple-500 text-white text-center text-xl rounded-md disabled:opacity-50 disabled:pointer-events-none"
                        :disabled="!selectedDate && currentVaccinationAnswer === 'vaccinated'"
                        @click="addToVaccinationIndex(1)"
                      >
                        Siguiente
                      </button>
                    </div>
                    <div class="text-sm w-full text-center mt-2">
                      {{ currentDoseIndex + 1 }} / {{ shouldAskLastDose ? 3 : 2 }}
                    </div>
                  </div>
                </div>
              </transition>
              <div
                v-for="categoryID in filteredCategoryIDs"
                :key="categoryID"
                class="mb-10 bg-bluegray-500 rounded-md pb-2"
              >
                <div
                  class="max-w- m-auto text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky top-16 z-30"
                >
                  {{ categories[categoryID].name }}
                </div>
                <div
                  :id="`${categoryID}-header`"
                  :ref="categoryID"
                  class="max-w- m-auto h-1 text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky -top-1 z-30 invisible"
                />
                <div
                  v-if="instanceID === 'n0w9z6Wnjnmw7yHxjvIl' && categoryID ==='symptoms'"
                  class="m-3 p-4 bg-white rounded-lg border border-red-500 text-red-500 font-bold"
                >
                  Los síntomas relacionados a condición de salud previas o crónicas NO se reportan.
                </div>
                <label
                  v-if="categoryID === 'symptoms' && askForTemperature && answers.symptoms && (!answers.symptoms['no-symptoms'] || answers.symptoms['no-symptoms'] === false)"
                  class="block"
                >
                  <div class="font-bold text-purple-500 text-center mb-2 text-lg">
                    Ingresa tu Temperatura
                  </div>
                  <div class="w-100 flex justify-center mb-2">
                    <a
                      @click="temperature -= 0.1"
                    >
                      <eva-icon
                        name="arrow-down"
                        fill="#6C63FF"
                        width="32"
                        height="32"
                        animation="pulse"
                      />
                    </a>
                    <div
                      :class="`text-center font-bold bg-purple-200 rounded text-2xl w-32  ${temperature > temperatureLimit ? 'text-red-500': 'text-purple-500'}`"
                    >
                      <div>
                        {{ Math.round(temperature * 10) / 10 }}°C
                      </div>
                    </div>
                    <a
                      @click="temperature += 0.1"
                    >
                      <eva-icon
                        name="arrow-up"
                        fill="#6C63FF"
                        width="32"
                        height="32"
                        animation="pulse"
                      />
                    </a>
                  </div>
                  <f7-range
                    class="my-10"
                    :min="32"
                    :max="42"
                    :step="0.1"
                    :value="temperature"
                    @range:change="temperature = $event"
                  />
                </label>
                <label
                  v-for="fieldID in categories[categoryID].fieldIDs"
                  :key="fieldID"
                  :class="`custom-label flex my-2 cursor-pointer border py-4 px-2 rounded-lg bg-white mx-2 ${ shouldHide(categoryID, fieldID) ? 'absolute invisible pointer-events-none select-none': ''}`"
                >
                  <div
                    v-if="answers[categoryID]"
                    :class="`flex-shrink-0 ${getBackground(categoryID, fieldID)} rounded-lg w-12 h-12 p-1 flex justify-center items-center`"
                  >
                    <input
                      type="checkbox"
                      class="hidden"
                      :value="`${categoryID}_${fieldID}`"
                      :checked="answers[categoryID][fieldID]"
                      @change="handleInput($event, categoryID, fieldID)"
                    >
                    <svg
                      :class="`opacity-25 w-6 h-6 pointer-events-none`"
                      viewBox="0 0 172 172"
                    ><g
                      fill="none"
                      stroke-width="none"
                      stroke-miterlimit="10"
                      font-family="none"
                      font-weight="none"
                      font-size="none"
                      text-anchor="none"
                      style="mix-blend-mode:normal"
                    ><path d="M0 172V0h172v172z" /><path
                      d="M145.433 37.933L64.5 118.8658 33.7337 88.0996l-10.134 10.1341L64.5 139.1341l91.067-91.067z"
                      :fill="`${answers[categoryID][fieldID] ? 'white' : 'gray'}`"
                      stroke-width="2"
                    /></g></svg>
                  </div>
                  <span class="self-center text-base select-none ml-8 w-full">
                    {{ categories[categoryID].fields[fieldID].label }}
                  </span>
                </label>
                <div
                  :id="`${categoryID}-footer`"
                  :ref="categoryID"
                  class="max-w- m-auto h-1 text-lg font-bold text-white bg-purple-500 text-center py-2 rounded-tl-md rounded-tr-md sticky bottom-1 z-30 invisible"
                />
              </div>
            </div>
            <div v-else>
              <div>
                <person-access
                  v-if="isAllowedAutoRegistration && !isAdminReport"
                  :key="selectedPersonID"
                  class="max-w-lg mx-auto"
                  :personName="persons[selectedPersonID].name"
                  :personID="selectedPersonID"
                  :rules="rules[selectedPersonID]"
                  :personInstanceID="persons[selectedPersonID].instanceID"
                />
                <img
                  v-if="!alreadyReportedToday[selectedPersonID].symptomatic"
                  class="w-64 mx-auto mt-10 mb-4"
                  src="@/assets/celebration.svg"
                  alt="celebration"
                >
                <img
                  v-else
                  class="w-32 mx-auto mt-10 mb-4"
                  src="@/assets/reports.svg"
                  alt="celebration"
                >
                <div class="text-center text-lg max-w-lg mx-auto">
                  <span class="text-purple-500 font-bold">{{ instance.name }}</span> agradece tu compromiso reportando, recuerda que al <span class="text-purple-500 font-bold">Cuidarte</span>, ¡nos cuidas a todos!
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showQRCode"
          class="bg-white"
        >
          <div>
            <div
              class="text-center text-4xl mt-10"
            >
              {{ date }} - {{ maxTimestamp }}
            </div>
            <div
              v-if="entryRiskLevel === 0"
              class="text-2xl mx-auto mt-12 max-w-xl text-center"
            >
              {{ entryApprovedMessage }}
            </div>
            <div
              v-else-if="entryRiskLevel === 1"
              class="text-2xl mx-auto mt-12 max-w-xl text-center"
            >
              {{ entryConditionedMessage }}
            </div>
            <div
              v-else
              class="text-2xl mx-auto mt-12 max-w-xl text-center"
            >
              {{ entryDeniedMessage }}
            </div>
            <div
              id="qr-code"
              class="flex justify-center mt-10 bg-white"
            />
            <div
              v-if="entryRiskLevel === 3"
              class="text-2xl mx-auto mt-12 max-w-xl text-center"
            >
              {{ entryDeniedMessage }}
            </div>
            <div
              class="text-xl mx-auto mt-10 max-w-xl text-center"
            >
              <span>
                Al
              </span>
              <img
                class="inline ml-5"
                src="@/assets/Cuidarte-purple.svg"
                alt="cuidarte"
              >
              <div>
                ¡nos cuidas a todos!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-else
      class="m-8 p-4 text-lg bg-bluegray-500 rounded-sm"
    >
      Parece que el numero {{ account.phoneNumber }} no tiene personas asignadas o estan deshabilitadas, por favor contacta a un administrador de la institucion si consideras que esto es un error.
    </div>
  </f7-page>
</template>

<script>
import { mapState } from 'vuex'
import * as axios from 'axios'
import moment from 'moment-timezone'
import { db, firebaseTools } from '../utils/firebase'
import qrcode from 'qrcode-generator'
import PersonAccess from '../components/personAccess'

export default {
  components: {
    PersonAccess,
  },
  props: {
    forcedPersonID: {
      type: String,
      default: null,
    },
    forcedInstanceID: {
      type: String,
      default: null,
    },
  },
  data () {
    return {
      vaccinationSended: [],
      loadedPersons: false,
      qr: null,
      selectedPersonID: null,
      date: null,
      answers: {},
      temperature: 37,
      userMenu: false,
      testCheck: false,
      rules: {},
      rulesBinds: {},
      ctx: null,
      stuckElementID: null,
      showCalendar: false,
      attributes: [
        {
          key: 'today',
          dot: 'purple',
          dates: new Date(),
        }
      ],
      selectedDate: null,
      doses: [
        'primera dosis',
        'segunda dosis',
        'dosis de refuerzo'
      ],
      currentDoseIndex: 0,
      currentVaccinationAnswer: 'vaccinated',
      currentVaccine: 'moderna',
      vaccinationAnswers: [],
      vaccinationOptions: {
        vaccinated: 'Sí',
        own: 'No, por decisión propia',
        medical: 'No, por recomendación médica',
        time: 'Aún no me la debo aplicar',
        unique: 'Mi vacuna es de dosis única',
      },
      hideVaccinationQuestionary: false,
    }
  },
  computed: {
    isJanssen () {
      if (typeof this.vaccinationAnswers[0] === 'undefined') return false
      return this.vaccinationAnswers[0].vaccine === 'janssen'
    },
    allowedAutoRegistrationTags () {
      return this.instance.allowedAutoRegistrationTags
    },
    shouldAskVaccination () {
      const today = Number(moment.tz('America/Bogota').startOf('day').format('x'))
      const twentyDaysAgo = 20 * 24 * 60 * 60 * 1000
      const vaccinationStatus = this.persons[this.selectedPersonID].vaccinationStatus
      if (!vaccinationStatus) {
        return true
      }
      const timestamp = vaccinationStatus.timestamp ? vaccinationStatus.timestamp.toMillis() : 0
      if (vaccinationStatus.value === 'unvaccinated' && (today - timestamp) > twentyDaysAgo) {
        return true
      }
      return false
    },
    shouldAskVaccinationDoses () {
      const today = Number(moment.tz('America/Bogota').startOf('day').format('x'))
      if (this.shouldAskFirstDoses || this.shouldAskLastDose) {
        if (!this.persons[this.selectedPersonID].nextVaccinationQuestionDay) {
          return true
        }
        if (this.persons[this.selectedPersonID].nextVaccinationQuestionDay.toMillis() <= today) {
          return true
        }
      }
      return false
    },
    shouldAskFirstDoses () {
      if (this.shouldAskLastDose) {
        return true
      }
      const personTagIDs = this.persons[this.selectedPersonID].tagIDs ? Object.keys(this.persons[this.selectedPersonID].tagIDs) : []
      for (const personTagID of Object.keys(this.askForFirstDosesTagIDs)) {
        if (personTagIDs.includes(personTagID)) {
          return true
        }
      }
      return false
    },
    shouldAskLastDose () {
      const personTagIDs = this.persons[this.selectedPersonID].tagIDs ? Object.keys(this.persons[this.selectedPersonID].tagIDs) : []
      for (const personTagID of Object.keys(this.askForLastDoseTagIDs)) {
        if (personTagIDs.includes(personTagID)) {
          return true
        }
      }
      return false
    },
    askForVaccinationStatus () {
      const personTagIDs = this.persons[this.selectedPersonID].tagIDs ? Object.keys(this.persons[this.selectedPersonID].tagIDs) : []
      for (const personTagID of Object.keys(this.askForVaccinationTagIDs)) {
        if (personTagIDs.includes(personTagID)) {
          return true
        }
      }
      return false
    },
    askForVaccinationTagIDs () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.parameters.askForVaccinationTagIDs || {}
    },
    askForFirstDosesTagIDs () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.parameters.askForFirstDosesTagIDs || {}
    },
    askForLastDoseTagIDs () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.parameters.askForLastDoseTagIDs || {}
    },
    temperatureLimit () {
      if (!this.instance) {
        return []
      }
      return this.instance.dictionary.parameters.temperatureLimit || 38
    },
    baseCategoryObject () {
      const base = {}
      for (const categoryID of this.filteredCategoryIDs) {
        base[categoryID] = {}
      }
      return base
    },
    filteredCategoryIDs () {
      const categoryIDs = []
      for (const categoryID of this.categoryIDs) {
        if (typeof this.categories[categoryID] === 'object') {
          if (this.fulfillsTagConditions(categoryID, this.selectedPersonID)) {
            const today = moment.tz('America/Bogota').startOf('day').format()
            let dayIndex = -1
            if (this.categories[categoryID].days && this.categories[categoryID].days.length >= 0) {
              dayIndex = this.categories[categoryID].days.findIndex(day => {
                return day.id === today
              })
            }
            if (!this.categories[categoryID].byDays || this.categories[categoryID].length > 0 || dayIndex >= 0) {
              categoryIDs.push(categoryID)
            }
          }
        }
      }
      return categoryIDs
    },
    entryDeniedMessage () {
      if (!this.persons[Object.keys(this.persons)[0]]) return ''
      const firstInstanceID = this.persons[Object.keys(this.persons)[0]].instanceID
      const firstInstance = this.instancesInfo[firstInstanceID]
      if (!firstInstance) {
        return 'No debes salir de casa ni puedes ingresar a las instalaciones de la institución.'
      }
      return firstInstance.dictionary.parameters.entryDeniedMessage || 'No debes salir de casa ni puedes ingresar a las instalaciones de la institución.'
    },
    entryApprovedMessage () {
      if (!this.persons[Object.keys(this.persons)[0]]) return ''
      const firstInstanceID = this.persons[Object.keys(this.persons)[0]].instanceID
      const firstInstance = this.instancesInfo[firstInstanceID]
      if (!firstInstance) {
        return 'Presentando el código QR se te permitirá ingreso.'
      }
      return firstInstance.dictionary.parameters.entryApprovedMessage || 'Presentando el código QR se te permitirá ingreso.'
    },
    entryConditionedMessage () {
      if (!this.persons[Object.keys(this.persons)[0]]) return ''
      const firstInstanceID = this.persons[Object.keys(this.persons)[0]].instanceID
      const firstInstance = this.instancesInfo[firstInstanceID]
      if (!firstInstance) {
        return 'Presentando el código QR se te permitirá ingreso.'
      }
      return firstInstance.dictionary.parameters.entryConditionedMessage || 'Al ingresar debes dirigirte a la enfermería.'
    },
    entryRiskLevel () {
      for (const reportedPersonID in this.alreadyReportedToday) {
        if (this.alreadyReportedToday[reportedPersonID].riskLevel === 3) return 3
      }
      for (const reportedPersonID in this.alreadyReportedToday) {
        if (this.alreadyReportedToday[reportedPersonID].riskLevel > 0) return 1
      }
      return 0
    },
    scrollToCategories () {
      if (!this.persons[Object.keys(this.persons)[0]]) return ''
      const firstInstanceID = this.persons[Object.keys(this.persons)[0]].instanceID
      const firstInstance = this.instancesInfo[firstInstanceID]
      if (!firstInstance) {
        return false
      }
      return firstInstance.dictionary.parameters.scrollToCategories || false
    },
    categories () {
      if (!this.instance) {
        return {}
      }
      return this.instance.dictionary.form.categories
    },
    categoryIDs () {
      if (!this.instance) {
        return []
      }
      return this.instance.dictionary.form.categoryIDs
    },
    askForTemperature () {
      return this.instance.dictionary.parameters.askForTemperature
    },
    isDoneReporting () {
      return Object.keys(this.alreadyReportedToday).length === Object.keys(this.persons).length
    },
    instanceID () {
      if (this.persons[this.selectedPersonID]) {
        return this.persons[this.selectedPersonID].instanceID
      }
      return null
    },
    canSubmit () {
      let allowed = true
      for (const categoryID of this.filteredCategoryIDs) {
        if (this.categories[categoryID].mandatory) {
          if (!this.answers[categoryID] || !Object.keys(this.answers[categoryID]).length) {
            allowed = false
          }
        }
      }
      console.info(this.shouldAskVaccinationDoses, this.vaccinationSended.indexOf(this.selectedPersonID) >= 0)
      if (this.shouldAskVaccinationDoses && !(this.vaccinationSended.indexOf(this.selectedPersonID) >= 0)) allowed = false
      return allowed
    },
    alreadyReportedToday () {
      const reportedToday = {}
      for (const personID in this.persons) {
        if (this.persons[personID].lastReported && this.persons[personID].lastReported.timestamp) {
          const today = Number(moment.tz('America/Bogota').startOf('day').format('x'))
          if (this.persons[personID].lastReported.timestamp.toMillis() > today) {
            reportedToday[personID] = { reported: true, symptomatic: this.persons[personID].lastReported.symptomatic, riskLevel: this.persons[personID].lastReported.riskLevel, instanceID: this.persons[personID].instanceID }
          }
        }
      }
      return reportedToday
    },
    instance () {
      return this.instancesInfo[this.instanceID]
    },
    isAllowedAutoRegistration () {
      return typeof this.allowedAutoRegistrationTags !== 'undefined'
    },
    showQRCode () {
      const entryRiskLevel = this.entryRiskLevel
      // eslint-disable-next-line no-extra-boolean-cast
      if (!!this.selectedPersonID || !this.persons || !Object.keys(this.persons).length) {
        return false
      } else {
        this.$nextTick(() => {
          const qrDiv = document.getElementById('qr-code')
          while (qrDiv.firstChild) {
            qrDiv.removeChild(qrDiv.lastChild)
          }
          const typeNumber = 4
          const errorCorrectionLevel = 'L'
          this.qr = qrcode(typeNumber, errorCorrectionLevel)
          this.qr.addData(`c_${this.account.phoneNumber}`)
          this.qr.make()
          this.ctx = document.createElement('canvas').getContext('2d')
          const ps = 5
          const moduleCount = this.qr.getModuleCount()
          this.ctx.canvas.width = ps * moduleCount
          this.ctx.canvas.height = ps * moduleCount
          this.ctx.fillStyle = entryRiskLevel === 0 ? '#6C63FF' : (entryRiskLevel === 1 ? '#FFC15E' : '#FF7570')
          for (let r = 0; r < moduleCount; r += 1) {
            for (let c = 0; c < moduleCount; c += 1) {
              if (this.qr.isDark(r, c)) {
                this.ctx.fillRect(c * ps, r * ps, ps, ps)
              }
            }
          }
          qrDiv.appendChild(this.ctx.canvas)
        })
        return true
      }
    },
    maxTimestamp () {
      if (typeof this.persons !== 'undefined') {
        const timestamps = Object.values(this.persons)
          .map(person => person.lastReported.timestamp.toMillis())
        return moment(Math.max(...timestamps), 'x').format('hh:mm a')
      }
      return null
    },
    isAdminReport () {
      return Boolean(this.forcedPersonID && this.forcedInstanceID)
    },
    ...mapState({
      account: state => state.auth.account,
      uid: state => state.auth.uid,
      instancesInfo: state => state.auth.instancesInfo,
      persons: state => state.access.persons,
      isAdmin: state => state.auth.isAdmin,
    }),
  },
  watch: {
    selectedPersonID () {
      this.currentDoseIndex = 0
      this.currentVaccinationAnswer = 'vaccinated'
      this.vaccinationAnswers = []
      this.currentVaccine = 'moderna'
      this.selectedDate = null
      this.hideVaccinationQuestionary = false
    },
    selectedDate: function () {
      this.showCalendar = false
    },
    baseCategoryObject () {
      this.answers = this.baseCategoryObject
    },
    temperature () {
      if (this.temperature > this.temperatureLimit) {
        this.$delete(this.answers.symptoms, 'no-symptoms')
        this.$set(this.answers.symptoms, 'fever', true)
      } else {
        this.$delete(this.answers.symptoms, 'fever')
      }
    },
  },
  mounted () {
    moment.locale('es')
    this.date = moment().tz('America/Bogota').format('DD MMMM YYYY')
    this.loadPersons()
    setTimeout(() => {
      if (this.scrollToCategories) {
        this.stuckElementID = this.filteredCategoryIDs[0]
        for (const categoryID of this.filteredCategoryIDs) {
          const stickyElm = this.$refs[categoryID][0]
          const stickyElm2 = this.$refs[categoryID][1]
          const observer = new IntersectionObserver(
            ([e]) => {
              let condition = false
              let type = ''
              if (e.target.id.split('-').length > 1) {
                type = e.target.id.split('-')[1]
                if (type === 'footer') {
                  condition = e.intersectionRatio === 1 && e.intersectionRatio > 0
                } else {
                  condition = e.intersectionRatio < 1 && e.intersectionRatio > 0
                }
              }
              if (condition) {
                this.stuckElementID = e.target.id.split('-')[0]
              }
            },
            { threshold: [1] }
          )
          observer.observe(stickyElm)
          observer.observe(stickyElm2)
        }
      }
    }, 1000)
  },
  beforeDestroy () {
    if (Object.keys(this.rulesBinds) > 0) {
      for (const bind of Object.values(this.rulesBinds)) {
        bind()
      }
    }
  },
  methods: {
    addToVaccinationIndex (addedNumber) {
      const isVaccinated = this.currentVaccinationAnswer === 'vaccinated' || this.currentVaccinationAnswer === 'unique'
      this.$set(this.vaccinationAnswers, this.currentDoseIndex, {
        vaccinated: isVaccinated,
        ...(isVaccinated ? { vaccine: this.currentVaccine } : {}),
        ...(this.currentVaccinationAnswer !== 'vaccinated' ? { reason: this.vaccinationOptions[this.currentVaccinationAnswer] } : {}),
        ...(this.selectedDate && this.currentVaccinationAnswer === 'vaccinated' ? { date: new Date(this.selectedDate.setHours(0, 0, 0, 0)) } : {}),
      })
      if (this.currentVaccinationAnswer === 'unique') {
        this.$set(this.vaccinationAnswers, this.currentDoseIndex, {
          ...this.vaccinationAnswers[this.currentDoseIndex],
          date: this.vaccinationAnswers[0].date,
        })
        this.$delete(this.vaccinationAnswers[this.currentDoseIndex], 'reason')
      }
      const lastDoseIndex = this.currentDoseIndex
      this.currentDoseIndex = null
      setTimeout(() => {
        this.currentDoseIndex = lastDoseIndex + addedNumber
        this.selectedDate = this.vaccinationAnswers[this.currentDoseIndex] ? this.vaccinationAnswers[this.currentDoseIndex].date || null : null
        if (this.vaccinationAnswers[this.currentDoseIndex]) {
          if (!this.vaccinationAnswers[this.currentDoseIndex]?.reason) {
            this.currentVaccinationAnswer = 'vaccinated'
          } else {
            for (const reasonKey of Object.keys(this.vaccinationOptions)) {
              if (this.vaccinationOptions[reasonKey] === this.vaccinationAnswers[this.currentDoseIndex]?.reason) {
                this.currentVaccinationAnswer = reasonKey
              }
            }
          }
        } else {
          this.currentVaccinationAnswer = 'vaccinated'
        }
        if ((typeof this.vaccinationAnswers[0] !== 'undefined' && this.vaccinationAnswers[0].vaccine === 'janssen') && this.currentDoseIndex === 1) {
          this.currentVaccinationAnswer = 'unique'
        }
        if ((this.currentDoseIndex > (this.shouldAskLastDose ? 2 : 1) || !isVaccinated) && addedNumber === 1) {
          if (!isVaccinated) {
            this.vaccinationAnswers.splice(this.currentDoseIndex, 1)
            this.vaccinationAnswers.splice(this.currentDoseIndex + 1, 1)
          }
          this.hideVaccinationQuestionary = true
          this.handleVaccinationInfo()
        }
      }, 50)
    },
    async handleVaccinationInfo () {
      try {
        this.$f7.preloader.show('Enviando información...')
        const response = await axios({
          url: '/users/submitVaccinationDates',
          method: 'POST',
          data: {
            userID: this.uid,
            personID: this.selectedPersonID,
            instanceID: this.instanceID,
            answers: this.vaccinationAnswers,
          },
        })
        console.info(response)
        this.vaccinationSended.push(this.selectedPersonID)
        this.$f7.preloader.hide()
      } catch (err) {
        console.error(err)
        this.$f7.preloader.hide()
        this.$f7.dialog.alert('Ocurrió un error reportando síntomas. Revisa tu conexión a internet.', '¡Ups!')
      }
    },
    formatDate (date) {
      return moment(date).tz('America/Bogota').format('DD MMM YYYY')
    },
    async reportVaccination (vaccinationStatus) {
      let text
      if (vaccinationStatus === 'wontGetVaccinated') {
        text = 'Estás a punto de reportar que <span class="font-bold text-red-500">NO planeas vacunarte.</span> ¿Deseas proceder?'
      }
      if (vaccinationStatus === 'unvaccinated') {
        text = 'Estás a punto de reportar que <span class="font-bold text-red-500">aún NO estás vacunado</span> ¿Deseas proceder?'
      }
      if (vaccinationStatus === 'vaccinated') {
        text = 'Estás a punto de reportar que <span class="font-bold text-purple-500">ya tienes el esquema completo de vacunación.</span> ¿Deseas proceder?'
      }
      await this.$f7.dialog.confirm(text, '¿Seguro?', async () => {
        try {
          this.$f7.preloader.show('Enviando información...')
          const response = await axios({
            url: '/users/submitVaccinationStatus',
            method: 'POST',
            data: {
              userID: this.uid,
              personID: this.selectedPersonID,
              instanceID: this.instanceID,
              vaccinationStatus,
            },
          })
          console.info(response)
          this.$f7.preloader.hide()
        } catch (err) {
          console.error(err)
          this.$f7.preloader.hide()
          this.$f7.dialog.alert('Ocurrió un error reportando síntomas. Revisa tu conexión a internet.', '¡Ups!')
        }
      })
    },
    loadPersons () {
      this.$store.commit('access/resetPersons')
      if (this.account.access) {
        const instances = Object.keys(this.account.access)
        let remainingInstances = instances.length
        if (this.isAdminReport) {
          db.collection('instances').doc(this.forcedInstanceID).collection('persons').doc(this.forcedPersonID).onSnapshot(personDoc => {
            if (personDoc.exists && personDoc.data().active !== false) {
              this.$store.commit('access/setPerson', { ID: this.forcedPersonID, data: personDoc.data(), instanceID: this.forcedInstanceID })
              this.loadedPersons = true
              this.selectedPersonID = this.forcedPersonID
            }
          })
        } else {
          for (const instanceID of instances) {
            remainingInstances--
            let remainingPersons = this.account.access[instanceID].length
            for (const personID of this.account.access[instanceID]) {
              db.collection('instances').doc(instanceID).collection('persons').doc(personID).onSnapshot(personDoc => {
                if (personDoc.exists && personDoc.data().active !== false) {
                  this.$store.commit('access/setPerson', { ID: personID, data: personDoc.data(), instanceID })
                  this.$set(this.rules, personID, {})
                  if (typeof this.rulesBinds[personID] === 'undefined') {
                    this.rulesBind = db.collection('instances').doc(instanceID).collection('rules').onSnapshot(snap => {
                      if (!snap.empty) {
                        snap.docChanges().forEach(change => {
                          if (change.type === 'added' || change.type === 'modified') {
                            this.$set(this.rules[personID], change.doc.id, {
                              id: change.doc.id,
                              ...change.doc.data(),
                            })
                          } else {
                            this.$delete(this.rules, change.doc.id)
                          }
                        })
                      }
                    }, (err) => { console.info(err.code) })
                  }
                  this.nextPerson()
                }
                if (remainingPersons > 0) remainingPersons--
                if (remainingInstances === 0 && remainingPersons === 0) {
                  this.loadedPersons = true
                }
              })
            }
          }
        }
      }
    },
    fulfillsTagConditions (categoryID, personID) {
      if (!this.categories[categoryID].byTags) {
        return true
      }
      if (!this.categories[categoryID].tagIDs || !this.persons[this.selectedPersonID].tagIDs) {
        return false
      }
      const categoryTagIDs = Object.keys(this.categories[categoryID].tagIDs)
      const personTagIDs = Object.keys(this.persons[this.selectedPersonID].tagIDs)
      let fulfills = false
      for (const categoryTagID of categoryTagIDs) {
        if (personTagIDs.includes(categoryTagID)) {
          fulfills = true
        }
      }
      return fulfills
    },
    askForLogout () {
      this.$f7.dialog.confirm('La próxima vez que abras la app deberás volver a entrar tu numero de celular.', '¿Estas seguro?', async () => {
        try {
          this.$f7.dialog.preloader('Eliminando datos locales...')
          await firebaseTools.signOut()
        } catch (err) {
          this.$f7.preloader.hide()
          console.error(err)
        }
      })
    },
    shouldHide (categoryID, fieldID) {
      if (categoryID === 'symptoms') {
        if (this.answers.symptoms['no-symptoms'] && fieldID !== 'no-symptoms') return true
      }
      return false
    },
    getSelectionClass (personID) {
      if (personID === 'qrCode') {
        if (this.showQRCode === true) {
          return 'bg-purple-500 text-white w-10 h-10 leading-8'
        }
        if (this.isDoneReporting) {
          return 'bg-purple-200 text-white w-10 h-10 leading-8'
        }
        return 'hover:bg-purple-200'
      }
      if (this.alreadyReportedToday[personID]) {
        if (personID === this.selectedPersonID) {
          if (this.alreadyReportedToday[personID].riskLevel === 3) {
            return 'bg-red-500 text-white w-10 h-10 leading-8'
          }
          if (this.alreadyReportedToday[personID].riskLevel === 2) {
            return 'bg-orange-500 text-white w-10 h-10 leading-8'
          }
          if (this.alreadyReportedToday[personID].riskLevel === 1) {
            return 'bg-yellow-500 text-white w-10 h-10 leading-8'
          }
          return 'bg-green-500 text-white w-10 h-10 leading-8'
        } else {
          if (this.alreadyReportedToday[personID].riskLevel === 3) {
            return 'bg-red-500 text-white w-10 h-10 leading-8'
          }
          if (this.alreadyReportedToday[personID].riskLevel === 2) {
            return 'bg-orange-500 text-white w-10 h-10 leading-8'
          }
          if (this.alreadyReportedToday[personID].riskLevel === 1) {
            return 'bg-yellow-500 text-white w-10 h-10 leading-8'
          }
          return 'bg-green-500 text-white'
        }
      }
      if (personID === this.selectedPersonID) {
        return 'bg-purple-500 text-white w-10 h-10 leading-8'
      }
      return 'hover:bg-purple-200 bg-white'
    },
    getBackground (categoryID, fieldID) {
      const weight = this.categories[categoryID].fields[fieldID].weight
      if (weight === 0) {
        if (this.answers[categoryID][fieldID]) {
          return 'bg-green-500'
        } else {
          return 'bg-green-100'
        }
      }
      if (weight === 1) {
        if (this.answers[categoryID][fieldID]) {
          return 'bg-yellow-500'
        } else {
          return 'bg-yellow-100'
        }
      }
      if (weight === 2) {
        if (this.answers[categoryID][fieldID]) {
          return 'bg-orange-500'
        } else {
          return 'bg-orange-100'
        }
      }
      if (weight === 3) {
        if (this.answers[categoryID][fieldID]) {
          return 'bg-red-500'
        } else {
          return 'bg-red-100'
        }
      }
      return 'bg-purple-100'
    },
    handleInput (e, categoryID, fieldID) {
      if (!this.answers[categoryID][fieldID]) {
        if (categoryID === 'symptoms' && fieldID === 'no-symptoms') {
          this.resetSymptoms()
          this.$f7.$('.page-content').scrollTop(0)
        }
        if (this.categories[categoryID].singleAnswer) {
          this.$set(this.answers, categoryID, {})
        }
        this.$set(this.answers[categoryID], fieldID, true)
      } else {
        if (categoryID === 'symptoms' && fieldID === 'fever' && this.temperature >= 37.5) {
          this.$f7.dialog.alert('La temperatura que registraste indica fiebre.', 'Revisa bien')
          return
        }
        this.$delete(this.answers[categoryID], fieldID)
      }
    },
    openAutoTest () {
      this.$f7router.navigate('/user-auto-test/')
    },
    openQuestionary () {
      this.$f7router.navigate('/user-questionary/')
    },
    handleSelect (personID) {
      this.resetSymptoms()
      if (personID) {
        this.selectedPersonID = personID
      } else {
        this.selectedPersonID = ''
      }
    },
    resetSymptoms () {
      this.temperature = 37
      this.answers.symptoms = {}
    },
    nextPerson () {
      this.resetSymptoms()
      for (const personID in this.persons) {
        if (!this.alreadyReportedToday[personID]) {
          this.selectedPersonID = personID
          return
        }
      }
      this.handleSelect()
    },
    async callSubmitAnswers () {
      try {
        this.$f7.preloader.show('Enviando información...')
        const response = await axios({
          url: '/users/submitAnswers',
          method: 'POST',
          data: {
            userID: this.uid,
            personID: this.selectedPersonID,
            instanceID: this.instanceID,
            answers: this.answers,
            isAdminReport: this.isAdminReport,
          },
        })
        this.$set(this, 'answers', this.baseCategoryObject)
        console.info(response)
        this.temperature = 37
        this.nextPerson()
        this.$f7.preloader.hide()
        if (this.isAdminReport) {
          this.$f7router.back()
        }
      } catch (err) {
        console.error(err)
        this.$f7.preloader.hide()
        this.$f7.dialog.alert('Ocurrió un error reportando síntomas. Revisa tu conexión a internet.', '¡Ups!')
      }
    },
    async submitAnswers () {
      if (this.scrollToCategories) {
        const lastCategoryID = this.filteredCategoryIDs[this.filteredCategoryIDs.length - 1]
        if (this.stuckElementID !== lastCategoryID) {
          // if (window.scrollHeight - window.scrollTop !== window.clientHeight) {
          const index = this.filteredCategoryIDs.indexOf(this.stuckElementID)
          const categoryID = this.filteredCategoryIDs[index + 1]
          const element = this.$refs[categoryID][0]
          const currentPage = document.getElementsByClassName('page-current')[0]
          const content = currentPage.childNodes[0]
          this.stuckElementID = element.id.split('-')[0]
          const y = element.getBoundingClientRect().top + content.scrollTop + 5
          content.scrollTo({
            top: y,
            behavior: 'smooth',
          })
          // element.scrollIntoView({ behavior: 'smooth' })
          return
          // }
        }
      }
      let hasRisk = false
      for (const categoryID of Object.keys(this.answers)) {
        if (this.answers[categoryID]) {
          for (const fieldID of Object.keys(this.answers[categoryID])) {
            if (this.categories[categoryID].fields[fieldID].weight) {
              hasRisk = true
            }
          }
        }
      }
      if (hasRisk) {
        this.$f7.dialog.confirm('Estás a punto de enviar un reporte con <span class="font-bold text-red-500">ciertos indicadores de riesgo</span>, ¿Seguro que deseas enviar el reporte?', '¿Seguro?', this.callSubmitAnswers)
      } else {
        await this.callSubmitAnswers()
      }
    },
  },
}
</script>
<style lang='scss'>
@import '../css/brand';
.chain-counter-footer {
  text-align: center;
  font-size: 18px;
}
.report-card {
  border: solid #51DFB8;
  padding: 10px;
  border-radius: 5px;
  max-width: $width-pc;
  margin: 100px auto $card-margin auto;
  text-align: right;
  position: relative;
}
.report-card > div:first-of-type {
  margin-left: 10px;
}
.report-icon {
  transform: translateY(3px);
  position:absolute;
  top: 5px;
  left: 5px;
}
.report-text {
  padding: 5px;
}
.report-image {
  width: 220px;
  position: absolute;
  opacity: 0.6;
  bottom: 60px;
  left: 15px;
}
.symptom-list {
  max-width: $width-pc;
  margin: $card-margin auto;
}
@media (max-width: 600px) {
  .symptom-list{
    margin: $card-margin;
  }
  .report-card{
    margin: 100px $card-margin $card-margin $card-margin;
  }
}
.symptom-list-item>label>div::after {
  display: none !important;
}
.symptom-list>ul::before {
  display: none !important;
}
.symptom-list>ul::after {
  display: none !important;
}
.form-title {
  width: 200px;
  margin: 20px auto;
  font-weight: bold;
}
.form-text {
  width: 250px;
  margin: 20px auto;
}
.custom-label input:checked + svg {
  opacity: 1 !important;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.blink {
  animation: blinker 2s linear infinite;
}

$track-color: #eceff1 !default;
$thumb-color:  $primary-color !default;

$thumb-radius: 24px !default;
$thumb-height: 48px !default;
$thumb-width: 48px !default;
$thumb-shadow-size: 4px !default;
$thumb-shadow-blur: 4px !default;
$thumb-shadow-color: rgba(0, 0, 0, .2) !default;
$thumb-border-width: 2px !default;
$thumb-border-color: #eceff1 !default;

$track-width: 100% !default;
$track-height: 2px !default;
$track-shadow-size: 1px !default;
$track-shadow-blur: 1px !default;
$track-shadow-color: rgba(0, 0, 0, .2) !default;
$track-border-width: 2px !default;
$track-border-color: #cfd8dc !default;

$track-radius: 5px !default;
$contrast: 5% !default;

@mixin shadow($shadow-size, $shadow-blur, $shadow-color) {
  box-shadow: $shadow-size $shadow-size $shadow-blur $shadow-color, 0 0 $shadow-size lighten($shadow-color, 5%);
}

@mixin track {
  cursor: pointer;
  height: $track-height;
  transition: all .2s ease;
  width: $track-width;
}

@mixin thumb {
  @include shadow($thumb-shadow-size, $thumb-shadow-blur, $thumb-shadow-color);
  background: $thumb-color;
  border: $thumb-border-width solid $thumb-border-color;
  border-radius: $thumb-radius;
  cursor: pointer;
  height: $thumb-height;
  width: $thumb-width;
}

.temp-range {
  -webkit-appearance: none;
  margin: $thumb-height / 2 0;
  width: $track-width;

  &:focus {
    outline: 0;

    &::-webkit-slider-runnable-track {
      background: lighten($track-color, $contrast);
    }

    &::-ms-fill-lower {
      background: $track-color;
    }

    &::-ms-fill-upper {
      background: lighten($track-color, $contrast);
    }
  }

  &::-webkit-slider-runnable-track {
    @include track;
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-webkit-slider-thumb {
    @include thumb;
    -webkit-appearance: none;
    margin-top: ((-$track-border-width * 2 + $track-height) / 2) - ($thumb-height / 2);
  }

  &::-moz-range-track {
    @include track;
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius;
  }

  &::-moz-range-thumb {
    @include thumb;
  }

  &::-ms-track {
    @include track;
    background: transparent;
    border-color: transparent;
    border-width: ($thumb-height / 2) 0;
    color: transparent;
  }

  &::-ms-fill-lower {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: darken($track-color, $contrast);
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius * 2;
  }

  &::-ms-fill-upper {
    @include shadow($track-shadow-size, $track-shadow-blur, $track-shadow-color);
    background: $track-color;
    border: $track-border-width solid $track-border-color;
    border-radius: $track-radius * 2;
  }

  &::-ms-thumb {
    @include thumb;
    margin-top: 0;
  }
}
.placeholder {
    position: relative;
    display: inline-block;
}

.placeholder::after {
    position: absolute;
    right: 5px;
    top: 16px;
    content: attr(data-placeholder);
    pointer-events: none;
    opacity: 0.6;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
.slide-fade-enter-active {
  transition: all .2s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for <2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
